/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Hip_AbductionInputs */

const en_us2_catalog_movement_hip_abduction = /** @type {(inputs: Catalog_Movement_Hip_AbductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hip abduction`)
};

const pt_br2_catalog_movement_hip_abduction = /** @type {(inputs: Catalog_Movement_Hip_AbductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abdução de quadril`)
};

const es_419_catalog_movement_hip_abduction = /** @type {(inputs: Catalog_Movement_Hip_AbductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abducción de cadera`)
};

const pt_pt2_catalog_movement_hip_abduction = /** @type {(inputs: Catalog_Movement_Hip_AbductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abdução da anca`)
};

const fr_fr2_catalog_movement_hip_abduction = /** @type {(inputs: Catalog_Movement_Hip_AbductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abduction de hanche`)
};

const de_de2_catalog_movement_hip_abduction = /** @type {(inputs: Catalog_Movement_Hip_AbductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüftabduktion`)
};

const it_it2_catalog_movement_hip_abduction = /** @type {(inputs: Catalog_Movement_Hip_AbductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abduzione dell'anca`)
};

/**
* | output |
* | --- |
* | "hip abduction" |
*
* @param {Catalog_Movement_Hip_AbductionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_hip_abduction = /** @type {((inputs?: Catalog_Movement_Hip_AbductionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Hip_AbductionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_hip_abduction(inputs)
	if (locale === "es-419") return es_419_catalog_movement_hip_abduction(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_hip_abduction(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_hip_abduction(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_hip_abduction(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_hip_abduction(inputs)
	return en_us2_catalog_movement_hip_abduction(inputs)
});
export { catalog_movement_hip_abduction as "catalog.movement.hip_abduction" }